import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const ArrowUpIcon = ({ sx, ...props }: Props) => (
  <SvgIcon viewBox="0 0 30 30" sx={{ color: 'gray', ...sx }} {...props}>
    <path
      d="M9.26 19.26 15 13.54l5.74 5.72 1.76-1.76L15 10l-7.5 7.5 1.76 1.76Z"
      fill="#55A6FF"
    />
  </SvgIcon>
)

ArrowUpIcon.defaultProps = {
  sx: null,
}
